export class CompanyBase {
    id = 'id';
    name = 'bdeo';
    service_code = 'INSUR-BDEO';
    companyCode = 'TEST-COMPANY';
    smartphoto = {};
    showDamageSummary = false;
    showDamageCostEstimation = false;
    costEstimationInfo = {
        currency: '€',
        labourHourPrice: 0,
        paintHourPrice: 0,
        taxPercentage: 21,
        maxAllowableTax: 21,
        taxName: 'IVA'
    };
    closingFields = [];
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            if (value !== undefined) {
                this[key] = value;
            }
        });
    }
}
